<div class="text-center mt-5">
  <fgb-loading></fgb-loading>
  <p class="mt-2 mb-0">
    <em>{{ 'subscriptions.payment-processing' | translate }}</em>
  </p>
</div>
